import { Grid, Tab, Tabs, styled } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import useDispatch from "hooks/useDispatch";
import { getInvestmentFixedCurrentlyInfo, getInvestmentPortfolioCurrentlyInfo } from "store/slices/investment/investmentSlice";
import BoxInvestmentFund from "./Component/BoxInvestmentFund";
import { VALUE_INVESTMENT_FUND } from "pages/Wallet/constants";
import BoxInvestmentFixed from "./Component/BoxInvestmentFixed";

const dataTabs = [
  { id: 1, name: "Investment Fund" },
  { id: 2, name: "Investment Fixed" },
];

function InvestmentCart() {
  const dispatch = useDispatch()

  const [searchParams, setSearchParams] = useSearchParams()
  const investmentTab = +searchParams.get("investmentTab") || 1

  const handleChangeTab = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      investmentTab: newValue,
      investmentTabForm: newValue
    });
  };


  useEffect(() => {

    if (investmentTab === VALUE_INVESTMENT_FUND.Floating) {
      dispatch(getInvestmentPortfolioCurrentlyInfo())
    } else if (investmentTab === VALUE_INVESTMENT_FUND.Fixed) {
      dispatch(getInvestmentFixedCurrentlyInfo())
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investmentTab])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabsStyle value={investmentTab} onChange={handleChangeTab}>
          {dataTabs?.map((data) => (
            <Tab value={data.id} label={data.name} />
          ))}
        </TabsStyle>
      </Grid>

      <Grid item xs={12}>
        {investmentTab === VALUE_INVESTMENT_FUND.Floating ? (
          <BoxInvestmentFund />
        ) : (
          <BoxInvestmentFixed />
        )}
      </Grid>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),

  ".MuiTabs-flexContainer": {
    justifyContent: "start",
  },
  ".MuiTab-root": {
    marginRight: theme.spacing(5),
  },
}));

export default InvestmentCart;
